module.exports = "<div class=\"ui-g-12 ui-sm-12 card\">\n    <div class=\"ui-g-12 title\" [innerHTML]=\"post.title\">\n    </div>\n    <div *ngIf=\"post.image\" class=\"ui-g-12 img-container\">\n        <img src=\"{{ post.image }}\">\n    </div>\n    <div class=\"ui-g-12 content\">\n        <span [innerHTML]=\"post.excerpt | safeHTML\">\n        </span>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/fiscalia/component/news/wordpress-litte-post/wordpress-litte-post.component.html
// module id = ./src/app/fiscalia/component/news/wordpress-litte-post/wordpress-litte-post.component.html
// module chunks = main